import React, { useState } from "react";
import {
  departmentWiseHeader,
  departmentExpandHeader,
} from "pages/TeamZone/TeamZoneHeaders";
import { tableRowSx } from "services/constants";
import * as Mui from "@mui/material";
import { Loader } from "components/Loader";
import { themes } from "services/constants";
import { KeyboardArrowRight, KeyboardArrowDown } from "@mui/icons-material";
export const DepartmentWise = ({
  departmentReports,
  loading,
  setLeavePage,
  leavePage,
}) => {
  const [expandedRow, setExpandedRow] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const handleChangePage = (event, newPage) => {
    setLeavePage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setLeavePage(0);
  };

  return loading ? (
    <Loader info="Loading..." />
  ) : (
    <React.Fragment>
      <Mui.Grid
        container
        alignItems="center"
        justifyContent="center"
        sx={{ textAlign: "center", paddingY: 2 }}
      >
        <Mui.Grid item xs={12} sm={8} md={6}>
          <Mui.Typography
            variant="h6"
            sx={{
              fontSize: { xs: 18, sm: 20, md: 22 },
              fontWeight: "bold",
              whiteSpace: "nowrap",
            }}
          >
            Shift Attendance Report - Department wise
          </Mui.Typography>
        </Mui.Grid>
      </Mui.Grid>
      <Mui.TableContainer
        component={Mui.Paper}
        sx={{ mt: 2, width: "100%", maxHeight: 850 }}
      >
        <Mui.Table>
          <Mui.TableHead
            sx={{
              backgroundColor: themes.primary,
              position: "sticky",
              top: -1,
              zIndex: 10,
            }}
          >
            <Mui.TableRow sx={tableRowSx}>
              <Mui.TableCell></Mui.TableCell>
              {departmentWiseHeader.map((header) => (
                <Mui.TableCell
                  sx={{ color: themes.headLine, fontWeight: "bold" }}
                >
                  {header.name}
                </Mui.TableCell>
              ))}
            </Mui.TableRow>
          </Mui.TableHead>
          <Mui.TableBody>
            {departmentReports?.length === 0 ? (
              <Mui.TableRow sx={tableRowSx}>
                <Mui.TableCell colSpan={12} align="center">
                  <Mui.Alert severity="info">No data available</Mui.Alert>
                </Mui.TableCell>
              </Mui.TableRow>
            ) : (
              departmentReports
                ?.slice(
                  leavePage * rowsPerPage,
                  leavePage * rowsPerPage + rowsPerPage
                )
                .map((group_details) => (
                  <>
                    <Mui.TableRow sx={tableRowSx}>
                      <Mui.TableCell>
                        <Mui.IconButton
                          onClick={() => {
                            if (expandedRow === group_details.department_id) {
                              setExpandedRow(0);
                            } else {
                              setExpandedRow(group_details?.department_id);
                            }
                          }}
                        >
                          {group_details?.department_id === expandedRow ? (
                            <KeyboardArrowDown />
                          ) : (
                            <KeyboardArrowRight />
                          )}
                        </Mui.IconButton>
                      </Mui.TableCell>
                      {departmentWiseHeader.map((header) => (
                        <Mui.TableCell sx={{ color: themes.headLine }}>
                          <Mui.Tooltip title={group_details[header.key]}>
                            {group_details[header.key] ||
                            group_details[header.key] === 0
                              ? group_details[header.key]
                              : "N/A"}
                          </Mui.Tooltip>
                        </Mui.TableCell>
                      ))}
                    </Mui.TableRow>
                    {group_details?.department_id === expandedRow && (
                      <Mui.TableRow sx={tableRowSx}>
                        <Mui.TableCell colSpan={12}>
                          <Mui.TableContainer
                            sx={{
                              marginTop: 0,
                              marginLeft: "auto",
                              marginRight: "auto",
                              width: "100%px",
                            }}
                            className="w-96 border rounded"
                          >
                            <Mui.Table className="border">
                              <Mui.TableHead
                                sx={{
                                  backgroundColor: themes.primary,
                                  position: "sticky",
                                  top: -1,
                                  zIndex: 10,
                                }}
                              >
                                <Mui.TableRow sx={tableRowSx}>
                                  {departmentExpandHeader.map((header) => (
                                    <Mui.TableCell
                                      sx={{
                                        color: themes.headLine,
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {header.name}
                                    </Mui.TableCell>
                                  ))}
                                </Mui.TableRow>
                              </Mui.TableHead>
                              <Mui.TableBody>
                                {group_details?.shift_details?.length !== 0 ? (
                                  group_details?.shift_details?.map(
                                    (group_employee_details) => (
                                      <Mui.TableRow>
                                        {departmentExpandHeader.map(
                                          (header) => (
                                            <Mui.TableCell
                                              sx={{ color: themes.headLine }}
                                            >
                                              <Mui.Tooltip
                                                title={
                                                  group_employee_details[
                                                    header.key
                                                  ]
                                                }
                                              >
                                                {group_employee_details[
                                                  header.key
                                                ] ||
                                                group_employee_details[
                                                  header.key
                                                ] === 0
                                                  ? group_employee_details[
                                                      header.key
                                                    ]
                                                  : "N/A"}
                                              </Mui.Tooltip>
                                            </Mui.TableCell>
                                          )
                                        )}
                                      </Mui.TableRow>
                                    )
                                  )
                                ) : (
                                  <Mui.TableRow sx={tableRowSx}>
                                    <Mui.TableCell
                                      colSpan={12}
                                      sx={{ padding: 0.5 }}
                                    >
                                      <Mui.Alert severity="info">
                                        No data available
                                      </Mui.Alert>
                                    </Mui.TableCell>
                                  </Mui.TableRow>
                                )}
                              </Mui.TableBody>
                            </Mui.Table>
                          </Mui.TableContainer>
                        </Mui.TableCell>
                      </Mui.TableRow>
                    )}
                  </>
                ))
            )}
          </Mui.TableBody>
        </Mui.Table>
        {departmentReports?.length > 25 ? (
          <Mui.TablePagination
            className="custom-pagination"
            component="div"
            rowsPerPageOptions={[25, 50, 75, 100]}
            count={departmentReports?.length}
            rowsPerPage={rowsPerPage}
            page={leavePage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        ) : null}
      </Mui.TableContainer>
    </React.Fragment>
  );
};
